import React from 'react';

export default () =>{

    return	(
        <svg width="17" height="17" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.4923 8.84719H9.826L10.506 6.15281H7.1723L6.4923 8.84719ZM11.866 14.5L8.5323 13.9719L9.146 11.5416H5.814L5.066 14.5L1.7323 13.9719L2.346 11.5416H0V8.84719H3.026L3.706 6.15281H0V3.45843H4.386L5.1323 0.5L8.466 1.0281L7.854 3.45843H11.186L11.9323 0.5L15.266 1.0281L14.654 3.45843H17V6.15281H13.9723L13.2923 8.84719H17V11.5416H12.614L11.866 14.5Z" fill="black"/>
        </svg>

    )
}